import "../../../static/js/loaders/image-gallery";

$('[data-fancybox]').fancybox({
  padding: 0,
  margin: 0,
  loop: true,
  arrows: false,
  beforeShow: function (instance) {
    var current = (this.index + 1);
    var total = instance.group.length;
    $('.meta .current').text(current);
    $('.meta .total').text(total);
  },
});